const LAYOUTS = {
  STANDARD: 'standard',
  CLASSIC: 'classic',
  FRESH: 'fresh'
}

export default LAYOUTS



// WEBPACK FOOTER //
// ./node_modules/cube-ui/src/components/form/layouts.js